import PropTypes from 'prop-types';
import React from 'react';

import TradeInTile from 'trade-in/components/TradeInTiles/components/TradeInTile/TradeInTile.jsx';

import 'trade-in/components/TradeInTiles/TradeInTiles.scss';
import { ContentZonesService } from '@sm360/widget-commons-core-services';
import { AnalyticsService, TRACKING_TAGS as TAGS } from '@sm360/widget-commons-general';
import { Quote } from '@sm360/widget-commons-vehicle';
import OfficialTradeIn from 'trade-in/components/OfficialTradeIn/OfficialTradeIn.jsx';

const TradeInTiles = ({ descriptions, title, isShowroomV2Enabled, tradeInTileContent, quote }) => {
    const trackEvaluateVehicleCta = () => AnalyticsService.gaTrigger(TAGS.EVALUATE_MY_VEHICLE_CTA(quote.vehicle.model));
    const czHasCbb = ContentZonesService.getContentZone('widget.tradein', 'widget.tradein.hascbb');
    const hasCBB = czHasCbb && czHasCbb.getValue() === 'true';
    const instantEstimate = isShowroomV2Enabled && tradeInTileContent && hasCBB;

    return (
        <div className="tradeInTiles--section">
            <div className="tradeInTiles--title">
                <p className="sr-title-2 is-centered">{title}</p>
                <p className="sr-subtitle-2 is-centered">{descriptions}</p>
            </div>
            <div className="tradeInTiles--content">
                {instantEstimate ? (
                    <TradeInTile tileContent={tradeInTileContent} isShowroomV2Enabled={isShowroomV2Enabled} />
                ) : (
                    <OfficialTradeIn quote={quote} />
                )}
                <TradeInTile onClick={trackEvaluateVehicleCta} />
            </div>
        </div>
    );
};

TradeInTiles.defaultProps = {
    tradeInTileContent: null,
};

TradeInTiles.propTypes = {
    descriptions: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    tradeInTileContent: PropTypes.element,
    isShowroomV2Enabled: PropTypes.bool.isRequired,
    quote: PropTypes.instanceOf(Quote.QuoteModel).isRequired,
};

TradeInTiles.displayName = 'TradeInTiles';

export default TradeInTiles;
